"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTargetingRouterOrHref = exports.isTargetingHref = exports.isTargetingRouter = void 0;
// prettier is bound and determined to make this ugly, so...
/* eslint-disable */
/** Check if item is a RouterLink */
var isTargetingRouter = function (item) {
    return item && item.to !== undefined;
};
exports.isTargetingRouter = isTargetingRouter;
/** Check if item is a normal anchor tag (as opposed to a RouterLink) */
var isTargetingHref = function (item) {
    return item && item.href !== undefined;
};
exports.isTargetingHref = isTargetingHref;
/** Check if item is either a RouterLink or anchor tag (as opposed to a ReactNode) */
var isTargetingRouterOrHref = function (item) {
    return item && (item.href !== undefined || item.to !== undefined);
};
exports.isTargetingRouterOrHref = isTargetingRouterOrHref;
